module.exports = __webpack_public_path__ + "img/resource1.d22cf1d1.jpg";